import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCommonModule } from '@app/shared';
import { NotificationPopUpComponent } from './notification-pop-up.component';

@NgModule({
  declarations: [NotificationPopUpComponent],
  imports: [
    CommonModule,
    AppCommonModule
  ],
          exports: [
            NotificationPopUpComponent 
          ]
})
export class NotificationPopUpModule { }
